import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Animations } from "src/app/_helpers/animations";
import { DictionaryService } from "../../../dictionary/dictionary.service";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";

@Component({
  selector: "app-report-task-view",
  templateUrl: "./report-task-view.component.html",
  styleUrls: [
    "./../../../_styles/ion-grid-content-table.scss",
    "./report-task-view.component.scss",
  ],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class ReportTaskViewComponent implements OnInit, DataRowComponent {
  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Input()
  customData: string;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  descriptionSlidedDown: boolean;
  showUsers: boolean = false;
  routerLink: string;

  constructor(public dictionaryService: DictionaryService, private elementRef: ElementRef) {}

  ngOnInit() {
    this.routerLink = `/app/report-task/edit-report-task/${this.row.idReport}/${this.row.id}`;

    this.setType();    
    
    // FIXME:
    setTimeout(() => {
      this.showUsers = true;
    }, 20);  
  }

  onShowDescription($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.descriptionSlidedDown = !this.descriptionSlidedDown;
  }

  onEmitEvent() {
    this.actionRequest.emit(this.row);
  }
  setType() {
    const value = this.dictionaryService.getDictionaryValueColor(
      this.dictionaryService.reportPriorityValues,
      this.row.report.priority);
    this.elementRef.nativeElement.style.setProperty("--flag-color", value);
  }
}
